import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import AdminItem from 'components/@admin/AdminMenu/AdminItem';
import AccountIcon from 'mdi-react/AccountIcon';
import ClipboardTextClockOutlineIcon from 'mdi-react/ClipboardTextClockOutlineIcon';
import CompanyIcon from 'mdi-react/CompanyIcon';
import FileDownloadOutlineIcon from 'mdi-react/FileDownloadOutlineIcon';
import CloudUploadOutlineIcon from 'mdi-react/CloudUploadOutlineIcon';
import RobotOutlineIcon from 'mdi-react/RobotOutlineIcon';
import PencilIcon from 'mdi-react/PencilIcon';
import React from 'react';
import { I18n } from 'utils/i18n';

const icons = {
  companies: <CompanyIcon />,
  users: <AccountIcon />,
  content: <PencilIcon />,
  batch: <ClipboardTextClockOutlineIcon />,
  ota: <CloudUploadOutlineIcon />,
  ai: <RobotOutlineIcon />,
  'ommniosign-evidence': <FileDownloadOutlineIcon />,
};

const AdminMenu = () => {
  return (
    <Box
      component="section"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRight: theme => `1px solid ${theme.palette.secondary.extraLight}`,
        bgcolor: 'background.paper',
        width: 250,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: '20px',
        }}
      >
        <Typography variant="h5">{I18n.t('SuperAdminMenu.Title')}</Typography>
      </Box>
      <List sx={{ p: '10px' }}>
        {Object.entries(icons).map(([name, icon], index) => (
          <AdminItem name={name} key={name} icon={icon} index={index} />
        ))}
      </List>
    </Box>
  );
};

export default AdminMenu;
